import { createReducer } from '@reduxjs/toolkit';
import * as actions from 'store/findProvider/actions';
import * as globalActions from 'store/global/actions';

const metadataInitialState = {
  fromRoute: ''
};

export type MetadataState = typeof metadataInitialState;

export const metadataReducer = createReducer(metadataInitialState, {
  [actions.PROVIDER_SET_FROM_ROUTE]: (state, action) => {
    return { fromRoute: action.payload };
  },
  [actions.PROVIDER_CLEAR_FROM_ROUTE]: () => {
    return { fromRoute: '' };
  },
  [globalActions.RESET_METADATA]: () => {
    return metadataInitialState;
  }
});

export default metadataReducer;
